import { NavLink, useNavigate, useLocation } from "react-router-dom"
import { userData } from "../utils/constants";
import { useDispatch } from "react-redux";
import { setLogout } from "../store/reducers/auth";

const MyAccountLink = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(setLogout());
        localStorage.removeItem(userData);

        navigate("/");
    };
    
    const isOrderHistoryActive = location.pathname.startsWith('/myorders') || location.pathname.startsWith('/orderdetail');
    
    const isAddressActive = location.pathname.startsWith('/myaddress') || location.pathname.startsWith('/addaddress');
    
    return (
        <div className="d-flex flex-column gap-2 w-100">
            <NavLink 
                to="/myorders" 
                className={() => `btn d-flex align-items-center justify-content-start py-3 px-4 mb-2 fw-medium transition-hover border-0 ${isOrderHistoryActive ? 'bg-dark text-white shadow-sm' : 'bg-light text-dark'}`}
                style={{ borderRadius: '10px' }}
            >
                <i className="fas fa-shopping-bag mr-3" style={{ width: '20px', textAlign: 'center' }}></i> Order History
            </NavLink>
            
            <NavLink 
                to="/wish" 
                className={({ isActive }) => `btn d-flex align-items-center justify-content-start py-3 px-4 mb-2 fw-medium transition-hover border-0 ${isActive ? 'bg-dark text-white shadow-sm' : 'bg-light text-dark'}`}
                style={{ borderRadius: '10px' }}
            >
                <i className="fas fa-heart mr-3" style={{ width: '20px', textAlign: 'center' }}></i> Personal Wishlist
            </NavLink>
            
            <NavLink 
                to="/myaccount" 
                className={({ isActive }) => `btn d-flex align-items-center justify-content-start py-3 px-4 mb-2 fw-medium transition-hover border-0 ${isActive ? 'bg-dark text-white shadow-sm' : 'bg-light text-dark'}`}
                style={{ borderRadius: '10px' }}
            >
                <i className="fas fa-user-circle mr-3" style={{ width: '20px', textAlign: 'center' }}></i> Profile Settings
            </NavLink>
            
            <NavLink 
                to="/myaddress" 
                className={() => `btn d-flex align-items-center justify-content-start py-3 px-4 mb-2 fw-medium transition-hover border-0 ${isAddressActive ? 'bg-dark text-white shadow-sm' : 'bg-light text-dark'}`}
                style={{ borderRadius: '10px' }}
            >
                <i className="fas fa-map-marker-alt mr-3" style={{ width: '20px', textAlign: 'center' }}></i> Saved Addresses
            </NavLink>
            
            <button 
                onClick={handleLogout} 
                className="btn d-flex align-items-center justify-content-start py-3 px-4 mb-2 fw-medium transition-hover border-0 bg-danger text-white shadow-sm"
                style={{ borderRadius: '10px' }}
            >
                <i className="fas fa-sign-out-alt mr-3" style={{ width: '20px', textAlign: 'center' }}></i> Sign Out
            </button>
        </div>
    );
}

export default MyAccountLink;